import React from 'react';
import './Publications.css';

const SidebarProfile = () => (
  <aside className="sidebar-profile">
    <img src="./vinhkhiem_picture_picture.jpg" alt="Khiem Vinh Tran" className="sidebar-profile-img" />
    <h2 className="sidebar-profile-name">Khiem Vinh Tran</h2>
    <p className="sidebar-profile-title">Research Staff Member & Associate Lecturer</p>
    <p className="sidebar-profile-department">Faculty of Information System & Information System Laboratory</p>
    <p className="sidebar-profile-university">University of Information Technology, Vietnam National University, Ho Chi Minh City</p>
    <div className="profile-location">
      <i className="fas fa-map-marker-alt"></i>
      <span>
        <a href="https://maps.app.goo.gl/zVvn2fYphGEJXVRF7" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: '#007bff' }}>
          Room E9.1, UIT-VNUHCM, Quarter 6, Linh Trung, Thu Duc City
        </a>
      </span>
    </div>
    <div className="sidebar-social-links">
      <a href="mailto:khiemtv@uit.edu.vn" className="sidebar-social-link email" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-envelope"></i> Email
      </a>
      <a href="https://scholar.google.com.vn/citations?user=XT2PrJQAAAAJ&hl=vi" className="sidebar-social-link scholar" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-graduation-cap"></i> Google Scholar
      </a>
      <a href="https://orcid.org/0000-0001-7128-2058" className="sidebar-social-link orcid" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-orcid"></i> ORCID
      </a>
      <a href="https://www.linkedin.com/in/khiem-tran-vinh/" className="sidebar-social-link flickr" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin"></i> LinkedIn
      </a>
      <a href="https://www.instagram.com/kvt0012/" className="sidebar-social-link instagram" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i> Instagram
      </a>
    </div>
  </aside>
);

const Publications = () => {
  return (
    <main className="main">
      <div className="sidebar-layout">
        <SidebarProfile />
        <div className="container">
          <div className="page-header">
            <h1>Publications</h1>
          </div>
          <div className="content-section publications-content">
            <ol className="publications-list">
              <li className="publication-item">
                Hoa Quang Le, Huong Xuan Dieu Kieu, <b>Khiem Vinh Tran</b>, Binh Thanh Nguyen, "LawViVQA: A Visual Question Answering Dataset for Vietnamese Legal Content,"<br/>
                <i>2024 RIVF International Conference on Computing and Communication Technologies (RIVF), Danang, Vietnam, 2024, pp. 393-397</i>
              </li>
              <li className="publication-item">
                <b>Khiem Vinh Tran</b>, Hao Phu Phan, Kiet Van Nguyen, Ngan Luu Thuy Nguyen.<br/>
                ViCLEVR: a visual reasoning dataset and hybrid multimodal fusion model for visual question answering in Vietnamese.<br/>
                <i>Multimedia Systems 30, 199 (2024)</i>
              </li>
              <li className="publication-item">
                Vo, Tam Minh, and <b>Khiem Vinh Tran</b>.<br/>
                "Generative Pre‐Trained Transformer for Vietnamese Community‐Based COVID‐19 Question Answering."<br/>
                <i>Creative Approaches Towards Development of Computing and Multidisciplinary IT Solutions for Society (2024): 265-277.</i>
              </li>
              <li className="publication-item">
                <b>Khiem Vinh Tran</b>, Kiet Van Nguyen, Ngan Luu Thuy Nguyen,<br/>
                "BARTPhoBEiT: Pre-trained Sequence-to-Sequence and Image Transformers Models for Vietnamese Visual Question Answering,"<br/>
                <i>2023 International Conference on Multimedia Analysis and Pattern Recognition (MAPR), Quy Nhon, Vietnam, 2023, pp. 1-6.</i>
              </li>
              <li className="publication-item">
                Truong Du Chau, X., Toan Nguyen, T., <b>Khiem Tran</b>, V., Quach, S., Thaichon, P., Jo, J., Vo, B., Dieu Tran, Q., & Viet Hung Nguyen, Q.<br/>
                "Towards a Review-Analytics-as-a-Service (RAaaS) Framework for SMEs: A Case Study on Review Fraud Detection and Understanding."<br/>
                <i>Australasian Marketing Journal, 32(1), 76-90 (2023).</i>
              </li>
              <li className="publication-item">
                Khang Nguyen Duc Quach, Zhao Ren, <b>Khiem Vinh Tran</b>, Viet Hung Vu, Yongsik Chun, Thanh Tam Nguyen, Jun Jo (2023).<br/>
                "Short-Term Traffic Speed Prediction Using Hybrid LSTM-SVR Model."<br/>
                <i>In: Jo, J., et al. Robot Intelligence Technology and Applications 7. RiTA 2022. Lecture Notes in Networks and Systems, vol 642. Springer, Cham.</i>
              </li>
              <li className="publication-item">
                <b>Khiem Vinh Tran</b>, Hao Phu Phan, Khang Nguyen Duc Quach, Ngan Luu-Thuy Nguyen, Jun Jo, Thanh Tam Nguyen (2022).<br/>
                "A Comparative Study of Question Answering over Knowledge Bases."<br/>
                <i>In: Chen, W., Yao, L., Cai, T., Pan, S., Shen, T., Li, X. (eds) Advanced Data Mining and Applications. ADMA 2022. Lecture Notes in Computer Science(), vol 13725. Springer, Cham.</i>
              </li>
              <li className="publication-item">
                Son T Luu, Mao Nguyen Bui, Loi Duc Nguyen, <b>Khiem Vinh Tran</b>, Kiet Van Nguyen, Ngan Luu-Thuy Nguyen(2021).<br/>
                "Conversational Machine Reading Comprehension for Vietnamese Healthcare Texts."<br/>
                <i>In: Wojtkiewicz, K., Treur, J., Pimenidis, E., Maleszka, M. (eds) Advances in Computational Collective Intelligence. ICCCI 2021. Communications in Computer and Information Science, vol 1463. Springer, Cham.</i>
              </li>
              <li className="publication-item">
                Kiet Van Nguyen, <b>Khiem Vinh Tran</b>, Son T Luu, Anh Gia-Tuan Nguyen, Ngan Luu-Thuy Nguyen,<br/>
                "Enhancing Lexical-Based Approach With External Knowledge for Vietnamese Multiple-Choice Machine Reading Comprehension,"<br/>
                <i>IEEE Access, vol. 8, pp. 201404-201417, 2020</i>
              </li>
              <li className="publication-item">
                <b>Khiem Tran</b>, Hao Phan, Kiet Nguyen, and Ngan Luu Thuy Nguyen. 2020.<br/>
                "UIT-HSE at WNUT-2020 Task 2: Exploiting CT-BERT for Identifying COVID-19 Information on the Twitter Social Network."<br/>
                <i>In Proceedings of the Sixth Workshop on Noisy User-generated Text (W-NUT 2020), pages 383–387, Online. Association for Computational Linguistics.</i>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Publications; 